import decode from 'jwt-decode';
import auth0 from 'auth0-js';
import MD5 from 'crypto-js/md5';
import store from './../store';
// import Router from 'vue-router';

const ID_TOKEN_KEY = 'id_token';
const ACCESS_TOKEN_KEY = 'access_token';
const CLIENT_ID = 'Ml4Sq61kG3AL7nN0wHGC6vy0UEVkyQXN';
const CLIENT_DOMAIN = 'emg-digital.eu.auth0.com';
const REDIRECT = process.env.VUE_APP_REDIRECT_AUTH;
const REDIRECT_LOGOUT = process.env.VUE_APP_REDIRECT_LOGOUT;
const SCOPE = 'openid email ';
const AUDIENCE = 'https://obwan-services.emg-digital.com';

let auth = new auth0.WebAuth({
  clientID: CLIENT_ID,
  domain: CLIENT_DOMAIN
});

export function login() {
  auth.authorize({
    responseType: 'token id_token',
    redirectUri: REDIRECT,
    audience: AUDIENCE,
    scope: SCOPE
  });
}

// let router = new Router({
//    mode: 'history',
// }); 

export function logout() {
  clearIdToken();
  clearAccessToken();
  document.location.href = `https://${CLIENT_DOMAIN}/v2/logout?returnTo=${encodeURI(REDIRECT_LOGOUT)}`;
}

export function requireAuth(to, from, next) {
  if (!isLoggedIn()) {
    next({
      path: '/authorize'
    });
  } else {
    next();
  }
}

export function getIdToken() {
  return localStorage.getItem(ID_TOKEN_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function getUserInfo() {
  return new Promise((resolve, reject) => {
    if (!isLoggedIn()) reject('unauthenticated');
    auth.client.userInfo(getAccessToken(), (err, user) => {
      if (err) reject('userinfo');
      else {
        user.picture = `https://www.gravatar.com/avatar/${MD5(user.email.toLocaleLowerCase()).toString()}`;
        store.dispatch('setUser', user)
        resolve(user);
      }
    });
  });
}

function clearIdToken() {
  localStorage.removeItem(ID_TOKEN_KEY);
}

function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

// Helper function that will allow us to extract the access_token and id_token
function getParameterByName(name) {
  let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

// Get and store access_token in local storage
export function setAccessToken() {
  let accessToken = getParameterByName('access_token');
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

// Get and store id_token in local storage
export function setIdToken() {
  let idToken = getParameterByName('id_token');
  localStorage.setItem(ID_TOKEN_KEY, idToken);
}

export function isLoggedIn() {
  const idToken = getIdToken();
  return !!idToken && !isTokenExpired(idToken);
}

function getTokenExpirationDate(encodedToken) {
  const token = decode(encodedToken);
  if (!token.exp) { return null; }

  const date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

function isTokenExpired(token) {
  const expirationDate = getTokenExpirationDate(token);
  return expirationDate < new Date();
}